'use client'

import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import { MobilePageTemplate } from '@/components/templates'
import styles from '@/features/Auth/ui/AuthWalletConnected/AuthWalletConnected.module.scss'
import { Button, Flex } from 'antd'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter()

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <MobilePageTemplate withTabs={false}>
      <Flex vertical justify="center" align="center" className="mobileContainer">
        <Flex className="w-full" flex={1} gap={15} justify="center" vertical align="center">
          <span className={styles.icon} style={{ fontSize: 80 }}>⚠️</span>
          <AppTitle text="Something went wrong" centered />
          <p className={styles.text}>An error occurred. Please try again.</p>
        </Flex>
        <div className="mt-auto w-full">
          <Flex vertical gap={10}>
            <Button onClick={() => router.replace('/')} className="mobilePrimaryButton" block type="primary">
              Go to home page
            </Button>
            <Button onClick={reset} className="mobileSecondaryButton" block type="default">
              Try again
            </Button>
          </Flex>
        </div>
      </Flex>
    </MobilePageTemplate>
  )
}
